import { fetchApi } from '@/config/axiosSetting';

import {
  GetBodyBankAccountQueryParamsType,
  GetBodyBankAccountQueryResponseType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyBankAccount/getBodyBankAccountQuery.type';

export const getBodyBankAccountQueryFunction = (
  params: GetBodyBankAccountQueryParamsType,
): Promise<GetBodyBankAccountQueryResponseType> => {
  return fetchApi.get(`/body/reports/${params.id}/bank_information/`);
};
